import React from "react";

import { bindActionCreators } from "redux";
import CarEvaluation from "./component";
import { selectCity } from "../../../components/desktop/cities/actions";
import { resetLeadFormData, setStep } from "../../../components/desktop/lead-form/actions";
import { setProgressBarData } from "../../../components/desktop/lead-progress-bar/actions";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";

const mapStateToProps = ({
    leadData: {
        activateLastStep,
        currentProgressStep: currentLeadStep,
        flowName,
        currentStep,
        currentTabIndex,
        variantActiveScreen
    },
    cities: { selectedCity },
    settings: { leadSource },
    leadProgressBar: { data }
}) => ({
    activateLastStep,
    currentLeadStep,
    selectedCity,
    flowName,
    leadSource,
    data,
    currentTabIndex,
    variantActiveScreen,
    currentStep
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setStepConnect: setStep,
    selectCityConnect: selectCity,
    resetLeadFormDataConnect: resetLeadFormData,
    setProgressBarDataConnect: setProgressBarData
}, dispatch);

export default withReducer(injectableReducers)(mapStateToProps, mapDispatchToProps)(CarEvaluation);
